import type { PropsWithChildren, FC } from 'react';

import { config, ContentContainer, HeroContainer } from '@eneco/custom-components/Hero';
import { Box, Grid, Image, PageGrid, Stack } from '@eneco/sparky';

export interface EndStepHeroProps extends PropsWithChildren<unknown> {
  heroImage: {
    value: {
      src: string;
    };
  };
}

export const EndStepHero: FC<EndStepHeroProps> = ({ heroImage, children }) => {
  return (
    <HeroContainer>
      <ContentContainer
        alignY="justify"
        hasBottomPlaceholder={false}
        hasRightPlaceholder={true}
        isVariableHeight={false}>
        <Stack.Item>
          <PageGrid>
            <PageGrid.Item gridColumn="1/-1">
              <Box paddingTop={{ initial: '8', lg: '16' }} paddingBottom={{ initial: '8', lg: '16' }}>
                <Grid gridTemplateColumns={{ initial: '1fr', lg: '1fr 1fr' }} columnGap={{ lg: '8', xl: '16' }}>
                  <Grid.Item
                    order={{
                      initial: 2,
                      lg: 1,
                    }}>
                    <Box paddingTop={{ initial: '2', lg: '0' }} paddingBottom={{ initial: '2', lg: '0' }}>
                      {children}
                    </Box>
                  </Grid.Item>
                  <Grid.Item
                    order={{
                      initial: 1,
                      lg: 2,
                    }}>
                    {heroImage?.value?.src && (
                      <Image
                        src={heroImage?.value.src}
                        alt=""
                        width="100%"
                        height={{
                          initial: config.minHeight.initial,
                          sm: config.minHeight.sm,
                          md: config.minHeight.md,
                          lg: '100%',
                        }}
                        objectFit="contain"
                      />
                    )}
                  </Grid.Item>
                </Grid>
              </Box>
            </PageGrid.Item>
          </PageGrid>
        </Stack.Item>
      </ContentContainer>
    </HeroContainer>
  );
};
